import styled from "styled-components";

const HoursGrid = styled.div`
    display: grid;
    grid-template-columns: 30% 35% 35%;
    width: 90%;
    max-width: 600px;
`;

const HoursCell = styled.div`
    font-size: 1rem;
    text-align: center;
    padding: 3px;
`;

const HoursCellToday = styled(HoursCell)`
    background-color: #b13537;
    color: white;
`;

const HoursLabel = styled.div`
    text-align: center;
    font-size: 28px;
    font-family: "Sue Ellen Francisco", cursive;
`;

const MapContainer = styled.div`
    width: 100%;
    max-width: 800px;
    margin-bottom: 30px;
`;

const Map = () => (
    <MapContainer>
        <iframe
            class="google-map"
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3155.196160869916!2d-122.47102638528429!3d37.738542022017384!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x808f7deaa5610c1b%3A0xd4d1cef60b2a0608!2sXiao+Loong+Restaurant!5e0!3m2!1sen!2sus!4v1542604682296"
            frameborder="0"
            allowfullscreen
        ></iframe>
    </MapContainer>
);

export const hours = {
    halfDay: {
        lunch: "Closed",
        dinner: "5:00PM to 8:30PM"
    },
    longDay: {
        lunch: "11:30AM to 2:00PM",
        dinner: "5:00PM to 8:30PM"
    },
    normal: {
        lunch: "11:30AM to 2:00PM",
        dinner: "5:00PM to 8:30PM"
    }
};

const BusinessHours = () => {
    const schedule = [
        { day: "Sunday", hours: hours.halfDay },
        { day: "Monday", hours: hours.halfDay },
        { day: "Tuesday", hours: hours.normal },
        { day: "Wednesday", hours: hours.normal },
        { day: "Thursday", hours: hours.normal },
        { day: "Friday", hours: hours.longDay },
        { day: "Saturday", hours: hours.longDay }
    ];

    return (
        <HoursGrid>
            <HoursLabel>Day</HoursLabel>
            <HoursLabel>Lunch</HoursLabel>
            <HoursLabel>Dinner</HoursLabel>
            {schedule.map((item, idx) => {
                const Wrapper =
                    idx === new Date().getDay() ? HoursCellToday : HoursCell;
                return (
                    <>
                        <Wrapper>{item.day}</Wrapper>
                        <Wrapper>{item.hours.lunch}</Wrapper>
                        <Wrapper>{item.hours.dinner}</Wrapper>
                    </>
                );
            })}
        </HoursGrid>
    );
};

const ContactUs = props => {
    return (
        <div class="contact">
            <div class="contact-container">
                <h1>Business Hours</h1>
                <BusinessHours />
                <h1>Contact &amp; Location</h1>
                <div class="address">
                    <div class="contact-details">
                        <span>Call Us!</span>
                        <a href="tel:1-415-753-5678" rel="nofollow">
                            415-753-5678
                        </a>
                    </div>
                    <div class="contact-details">
                        <span>Visit Us!</span>
                        <a
                            href="https://www.google.com/maps/search/?api=1&query=250%20West%20Portal%20Avenue%20San%20Francisco%20California%2094127"
                            target="_blank"
                            rel="noopener"
                        >
                            250 West Portal Avenue, San Francisco, CA 94127
                        </a>
                    </div>
                </div>
                <Map />
            </div>
        </div>
    );
};

export default ContactUs;
